import styled from "styled-components";

export const Form = styled.form``;

export const InputContent = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  margin-top: -29px;
  gap: 8px;
`;
